import { render } from "./WebsiteForm.vue?vue&type=template&id=a8c659c2&scoped=true"
import script from "./WebsiteForm.vue?vue&type=script&lang=js"
export * from "./WebsiteForm.vue?vue&type=script&lang=js"

import "./WebsiteForm.vue?vue&type=style&index=0&id=a8c659c2&scoped=true&lang=css"

import exportComponent from "D:\\Coding\\welikethespeech\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c659c2"]])

export default __exports__